<template>
  <b-card>
    <b-card-title>
      Purple Scribe
    </b-card-title>

    <!-- Handle Processing Status -->
    <section v-if="showWaiting || purpleScribeStatus === 'processing'">
      <p>The visit is currently being ran through purple scribe. Please refresh the page shortly to see the transcript and summaries.</p>
    </section>

    <!-- Handle None state -->
    <section v-else-if="purpleScribeStatus === 'none'">
      <b-btn
        variant="success" class="full-width"
        @click="generateScribe()"
      >
        Generate Transcript & Summary for this Call
      </b-btn>
    </section>

    <!-- Handle failed status -->
    <section v-else-if="purpleScribeStatus === 'failed'">
      <p>Purple Scribe has encountered an issue with this visit. Please contact support.</p>
    </section>

    <!-- Handle Ready Status -->
    <section v-else-if="purpleScribeStatus === 'ready'">
      <section v-if="!loading">
        <div v-if="summaries && summaries.length > 0" class="mt-1">
          <h4>Summaries</h4>

          <ScribeSummary
            v-for="summary in summaries"
            :key="summary.id"
            :summary="summary"
          />
        </div>

        <div v-if="transcript && transcript.transcript" class="mt-1">
          <h4>Transcript</h4>
          <div class="row">
            <div class="col-12">
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <td class="transcript">
                      {{ transcript.transcript }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section v-else>
        <div class="mt-1">
          <p>Loading...</p>
        </div>
      </section>
    </section>

  </b-card>
</template>

<script>
import PurpleScribeTranscriptService from '@/services/PurpleScribeTranscriptService';
import { logger } from '@/util/logger';
import PurpleScribeSummaryService from '@/services/PurpleScribeSummaryService';
import ScribeSummary from '@/views/auditTrail/Summaries/ScribeSummary.vue';
import VisitService from '@/services/VisitService';

export default {
  name: 'PurpleScribe',
  components: { ScribeSummary },
  props: {
    visitId: {
      type: String,
      required: true,
    },
    purpleScribeStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showWaiting: false,
      transcript: null,
      summaries: [],
      loading: true,
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        const transcripts = await PurpleScribeTranscriptService.list(this.$props.visitId);
        const summaries = await PurpleScribeSummaryService.list(this.$props.visitId);

        // eslint-disable-next-line prefer-destructuring
        this.transcript = transcripts.data[0];
        this.summaries = summaries.data;

        this.loading = false;
      } catch (err) {
        logger.error('Error getting purple scribe details', err, null, 'PurpleScribe:getData');
        this.$toast.error('There was an error fetching the purple scribe details. Please try again later.', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }
    },
    generateScribe() {
      // Send request
      VisitService.purpleScribeGenerate(this.$props.visitId).catch(err => {
        logger.error('Error generating purple scribe', err, { visitId: this.visit._id }, 'PurpleScribe:generateScribe');
      });
      // Set waiting to true
      this.showWaiting = true;
    },
  },
}
</script>

<style>
.transcript {
  white-space: pre-line;
}
</style>
